import Api from '@/services/Api'

export default {
  getBusinessAccounts(type, page) {
    if (!type)
      return Api().get(`/media/index?page=${page}`)
    else return Api().get(`/media/index?type=${type}&page=${page}`)
    // return Api().get(`/media/index?page=${page}`)
  },
}